module.exports = __webpack_public_path__ + "static/media/one_building_hour.5bb3f4d5.csv";